import React, { useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Col, CardBody, Card, Row } from 'reactstrap';
import { Link } from 'react-router-dom';

import AddEditBreachTypeOfEvidenceModal from './Add_Edit/Add_EditBreachTypeOfEvidence';
import DeleteBreachTypeOfEvidenceModal from './Delete/DeleteBreachTypeOfEvidence';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import { getBreachTypeOfEvidenceListQuery } from '../../../../slices/breachTypeOfEvidence/thunk';
import { Icons } from '../../../../utils/Icons';

const BreachTypeOfEvidenceList = () => {
	const dispatch = useDispatch();

	const [dataBreachTypeOfEvidence, setDataBreachTypeOfEvidence] = useState({});
	const [refetch, setRefetch] = useState(0);
	const [isEdit, setIsEdit] = useState(false);
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);

	const toggleRefetch = () => {
		setRefetch(prev => prev + 1);
	};

	function handleToggleModal() {
		setModal(!modal);
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	const handleClickDelete = data => {
		setDataBreachTypeOfEvidence(data);
		setModalDelete(true);
	};

	const handleClickEdit = data => {
		setDataBreachTypeOfEvidence(data);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'breachTypeOfEvidences',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													setIsEdit(true);
													handleClickEdit(cellProps.row.original);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													handleClickDelete(cellProps.row.original);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{
				header: 'Nombre',
				accessorKey: 'name',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						<CardBody>
							<ODataGrid
								columns={columns}
								getDataFunc={getBreachTypeOfEvidenceListQuery}
								baseFilters={{
									disable: { $eq: false },
								}}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								refetchRemoteData={refetch}
								nameFile={'tipos-evidencia'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataBreachTypeOfEvidence({});
											handleToggleModal();
										},
										title: 'Crear Tipo de Evidencia',
									},
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditBreachTypeOfEvidenceModal
				dataBreachTypeOfEvidence={dataBreachTypeOfEvidence}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				toggleRefetch={toggleRefetch}
			/>
			<DeleteBreachTypeOfEvidenceModal
				dataBreachTypeOfEvidence={dataBreachTypeOfEvidence}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
				toggleRefetch={toggleRefetch}
			/>
		</React.Fragment>
	);
};

export default BreachTypeOfEvidenceList;
